import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d5db6612&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=d5db6612&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=d5db6612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db6612",
  null
  
)

export default component.exports